/**
 * Breakpoint
 */

export const breakpoint = {
  sd : '601px',
  md : '768px',
  lmd: '911px',
  lg : '1024px',
  mlg: '1280px',
  xlg: '1440px',
};
